module.exports = __webpack_public_path__ + "img/photo.40a79575.svg";